import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const color = createSlice({
  name: "color",
  initialState,
  reducers: {
    setColor: (state, action) => {
      return action.payload;
    },
    clearColor: () => {
      return initialState;
    },
  },
});

// Export actions and reducer
export const { setColor, clearColor } = color.actions;
export default color.reducer;
